import axios from '../axios';
// 职位列表分页信息
export const getBaseOfficePostPage = data => {
  return axios({
    url: '/api/sys/getBaseOfficePostPage',
    method: 'post',
    data
  })
};
// 职位删除
export const deleteBaseOfficePosts = data => {
  return axios({
    url: '/api/sys/deleteBaseOfficePosts',
    method: 'post',
    data
  })
};
export const save = data => {
  // 职位增
  if (!data.id) {
    return axios({
      url: '/api/sys/saveBaseOfficePost',
      method: 'post',
      data
    })
  } else {
    // 职位改
    return axios({
      url: '/api/sys/updateBaseOfficePost',
      method: 'post',
      data
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/moudules/position.js